import React from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';
import { getImgixUrl } from '../../../../../utils/helper';
import AddSwatchToCartButton from '../sidebar/fabricDescription/AddSwatchToCartButton';

const Wrapper = styled.div`
  width: 420px;
  right: 0;
  background: white;
  position: fixed;
  top: 0;
  z-index: 1010;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;

  .head-container {
    border: 1px solid #d8d8d8;
    padding: 20px;
  }
  .pattern-info {
    margin-top: 20px;
  }

  .details-container {
    height: 100%;
    padding: 15px;
    border-left: 1px solid #d8d8d8;
    .detail-fabric-container {
      width: 235px;
      height: auto;
      margin: 0 auto 20px auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .detail-composition,
    .detail-durability {
      display: flex;
      flex-direction: column;

      .durability-title,
      .composition-title {
        min-width: 120px;
        max-width: 120px;
      }
    }
  }

  .add-to-cart-swatch {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 992px) {
    overflow-y: scroll;
    width: 100%;
    top: 0px;
    height: calc(100% - 0px);
  }
`;

function ViewDetailSidebar({ setViewDetails, selectedFabric, productData }) {
  const isSwatchAvailable = productData?.fabric?.is_available;
  const isPurchasable = productData?.fabric?.swatch?.is_purchasable;

  return (
    <Wrapper>
      <div className="head-container">
        <BackText
          onClick={() => {
            setViewDetails(false);
          }}
        >
          {'<'} Back
        </BackText>
        <Title>Fabric Details</Title>
      </div>
      <div className="details-container">
        <div className="detail-fabric-container">
          <Imgix
            imgixParams={{ auto: 'compress,format' }}
            className="product-image"
            sizes="245px"
            src={getImgixUrl(selectedFabric.image)}
            htmlAttributes={{
              alt: selectedFabric.name
            }}
          />
        </div>
        {isSwatchAvailable && isPurchasable ? (
          <AddSwatchToCartButton
            className="add-to-cart-swatch"
            productData={productData}
          />
        ) : (
          ''
        )}
        <br />
        <FabricName>{selectedFabric.name}</FabricName>
        {selectedFabric.collaborator && (
          <Text>by {selectedFabric.collaborator.name}</Text>
        )}
        <br />

        {selectedFabric.description && (
          <>
            <Text>{selectedFabric.description}</Text>
            <br />
          </>
        )}
        {selectedFabric.material &&
          selectedFabric.material.composition &&
          selectedFabric.material.durability && (
            <>
              <div className="detail-composition">
                <Text className="composition-title" bold>
                  Composition
                </Text>
                <Text>{selectedFabric.material.composition}</Text>
              </div>
              <br />
              <div className="detail-durability">
                <Text className="durability-title" bold>
                  Durability
                </Text>
                <Text>{selectedFabric.material.durability}</Text>
              </div>
            </>
          )}
        {/* Pattern ID 15 is for rug "fabrics" that are not made to order */}
        {selectedFabric.pattern?.id && selectedFabric.pattern?.id != 15 && (
          <div className="pattern-info">
            {selectedFabric.pattern?.id == 3
              ? 'Please note each piece is made to order. Color may vary slightly from image.'
              : 'Please note each piece is made to order. Pattern placement and color may vary slightly from image.'}
          </div>
        )}
      </div>
    </Wrapper>
  );
}

export default ViewDetailSidebar;

const FabricName = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.charcoal};
`;

const Text = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ bold, theme }) => (bold ? (theme.old ? 'bold' : 600) : 'normal')};
  font-size: 16px;
  line-height: 20px;
  /* or 125% */

  color: ${({ theme }) => theme.colors.charcoal};
`;

const BackText = styled.div`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  color: #6c6c6c;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;
    position: absolute;
    left: 10px;
    top: 17px;
  }
`;

const Title = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary.family};
    letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'normal' : '300'};
  font-size: 36px;
  line-height: 46px;

  @media (max-width: 992px) {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;

    color: ${({ theme }) => theme.colors.charcoal};
  }
`;
